import type { ChangeEvent, FocusEvent } from "react";

/**
 * Fixes "can't clear the box": shows empty while editing (NaN to the form) and normalises empty to 0 on blur.
 * Spread AFTER `{...field}`: <Input type="number" {...field} {...numberFieldProps(field)} />
 */
export function numberFieldProps(field: {
  value: number;
  onChange: (value: number) => void;
  onBlur: () => void;
}) {
  return {
    value: Number.isFinite(field.value) ? field.value : "",
    onChange: (e: ChangeEvent<HTMLInputElement>) => field.onChange(e.target.valueAsNumber),
    onBlur: (e: FocusEvent<HTMLInputElement>) => {
      field.onBlur();
      if (e.target.value.trim() === "") field.onChange(0);
    },
  };
}
